import { Link } from 'react-router-dom';
import styled from 'styled-components';

const baseButton = styled.button`
  border: ${({ dark, theme }) => ( dark ? theme.buttons.primary.border : theme.buttons.secondary.border )};
  background: ${({ dark, theme }) => (dark ? theme.buttons.primary.backgroundColor : theme.buttons.secondary.backgroundColor)};
  border-radius: ${({ theme }) => theme.buttons.primary.borderRadius};
  color: ${({ dark, theme }) => (dark ? theme.buttons.primary.color : theme.buttons.secondary.color)};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.buttons.primary.fontSize};
  font-weight: ${({ theme }) => theme.buttons.primary.fontWeight};
  height: ${({ theme }) => theme.buttons.primary.height};
  letter-spacing: ${({ theme }) => theme.buttons.primary.letterSpacing};
  transition: all 0.2s ease;
`;

export const TransparentButton = styled.button`
  border: ${({ theme }) =>  theme.old ? '1px solid #d8d8d8' : 'none'};
  background: ${({ bg }) => bg};
  border-radius: ${({ theme }) => theme.buttons.primary.borderRadius};
  width: 270px;
  height: ${({ height }) => (height ? height : '56px')};
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
    border: 1px solid black;
  }
`;

export const TransparentLinkButton = styled(Link)`
  display: inline-block;
  border: 1px solid #d8d8d8;
  background: transparent;
  width: 270px;
  height: 56px;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: ${({ theme }) => theme.colors.charcoal};
  display: flex;
  justify-content: center;
  align-items: center;

  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }
`;

export const BorderedLink = styled(Link)`
  color: ${({ theme }) => theme.colors.french};
  .link-name {
    border-bottom: 2px solid #2a5caf;
  }

  &:hover {
    text-decoration: none;
  }
`;

export const BorderedButton = styled.button`
  color: ${({ color }) => (color ? color : '#2a5caf')};
  border: none;
  background: white;
  border: none;
  border-bottom: 2px solid
    ${({ borderColor, borderNone }) =>
      borderNone ? 'none' : borderColor ? borderColor : '#2a5caf'};
  outline: none;
  padding: 0;

  .link-name {
    border-bottom: 2px solid #2a5caf;
  }

  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.french};
    border-bottom: ${({ borderNone }) =>
      borderNone ? 'none' : '2px solid #2a5caf'};
    text-decoration: none;
  }
`;

export const LinkButton = styled.button`
  background: transparent;
  border: none;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.french};
  display: inline;
  padding: 0;
  margin: 0;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
  line-height: 17px;
`;

export const Button = styled(baseButton)`
  font-style: normal;
  line-height: 23px;
  width: 270px;

  &:disabled {
    background-color: ${({ dark, theme }) => (theme.buttons[dark ? 'primary' : 'secondary'].disabled.backgroundColor)};
    border: ${({dark, theme}) => (theme.buttons[dark ? 'primary' : 'secondary'].disabled.border)};
    color: ${({dark, theme}) => (theme.buttons[dark ? 'primary' : 'secondary'].disabled.color)};
    pointer-events: none;
  }

  &:hover {
    border: 1px solid ${({ dark, theme }) => (theme.buttons[dark ? 'primary' : 'secondary'].hover.border)};
    background: ${({ dark, theme }) => (theme.buttons[dark ? 'primary' : 'secondary'].hover.backgroundColor)};
    color: ${({ dark, theme }) => (theme.buttons[dark ? 'primary' : 'secondary'].hover.color)};
  }
`;

export const ButtonLink = styled(Link)`
  align-items: center;
  background: ${({ dark, theme }) => (dark ? theme.buttons.primary.backgroundColor : 'transparent')};
  border: ${({ dark, theme }) => ( dark ? theme.buttons.primary.border : '1px solid black' )};
  border-radius: ${({ theme }) => theme.buttons.primary.borderRadius};
  color: ${({ dark, theme }) => (dark ? theme.buttons.primary.color : theme.colors.charcoal)};
  display: inline-flex !important;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.buttons.primary.fontSize};
  font-style: normal;
  font-weight: ${({ theme }) => theme.buttons.primary.fontWeight};
  height: ${({ theme }) => theme.buttons.primary.height};
  justify-content: center;
  line-height: 23px;
  opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};
  padding: 1px 6px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: all 0.2s ease;
  width: 270px;

  &:hover {
    border: 1px solid #245caf;
    background: ${({ dark }) => (dark ? '#245CAF' : 'transparent')};
    color: ${({ dark }) => (dark ? 'white' : '#245CAF')};
    text-decoration: none;
  }
`;

export const ExternalButtonLink = styled.a`
  align-items: center;
  background: ${({ dark, theme }) => (dark ? theme.buttons.primary.backgroundColor : 'transparent')};
  border: ${({ dark, theme }) => ( dark ? theme.buttons.primary.border : '1px solid black' )};
  color: ${({ dark, theme }) => (dark ? theme.buttons.primary.color : theme.colors.charcoal)};
  display: inline-flex !important;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.buttons.primary.fontSize};
  font-style: normal;
  font-weight: ${({ theme }) => theme.buttons.primary.fontWeight};
  height: ${({ theme }) => theme.buttons.primary.height};
  justify-content: center;
  line-height: 23px;
  opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};
  padding: 1px 6px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: all 0.2s ease;
  width: 270px;

  &:hover {
    border: 1px solid #245caf;
    background: ${({ dark }) => (dark ? '#245CAF' : 'transparent')};
    color: ${({ dark }) => (dark ? 'white' : '#245CAF')};
    text-decoration: none;
  }
`;
export const ToggleSliderBtn = styled.span`
  cursor: pointer;
  display: block;
  height: 17px;
  position: relative;
  width: 30px;
  background: ${props => (props.open ? '#2A5CAF' : '#ccc')} none repeat scroll
    0% 0% / auto padding-box border-box;
  border-radius: 34px 34px 34px 34px;
  transition: all 0.2s ease;

  &:before {
    transform: ${props => (props.open ? 'matrix(1, 0, 0, 1, 13, 0)' : 'none')};
    content: '';
    height: 13px;
    left: 2px;
    position: absolute;
    text-align: left;
    top: 2px;
    width: 13px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
      border-box;
    border-radius: 50% 50% 50% 50%;
    transition: all 0.2s ease;
  }
`;

export const FilterButton = styled.button`
  cursor: pointer;
  margin: 5px;
  background: white;
  border: ${({ selected, borderColor }) =>
    selected
      ? `2px solid ${borderColor ? borderColor : `#A83569`}`
      : '1px solid #D8D8D8'};
  color: ${({ selected, theme }) => (selected ? theme.colors.charcoal: '#4B4B4B')};
  padding: 10px;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;

  letter-spacing: 0.04em;

  &:focus {
    outline: none;
  }
`;

export const UnderlineLink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.primary};
  text-decoration: underline ${({ theme }) => theme.buttons.link.color};
  color: ${({ theme }) => theme.buttons.link.color};
`;